<template>
  <v-dialog v-model="dialog.show" max-width="1000">
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-title>
        <v-btn
          outlined
          color="blue darken-2"
          rounded
          dark
          depressed
          small
          @click="$refs.dialogFormPrazo.show(false, {}, consorcio)"
        >
          <v-icon left>mdi-plus-circle</v-icon>Novo Prazo
        </v-btn>
      </v-card-title>
      <DialogFormPrazo
        ref="dialogFormPrazo"
        @created="data.push($event)"
        @updated="updatePrazo($event)"
      />
      <v-card-text>
        <v-data-table
          ref="dataTable"
          :headers="headers"
          :items="data"
          :search="search"
        >
          <template v-slot:top>
            <v-row dense>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  v-model="search"
                  label="Procurar..."
                  prepend-inner-icon="mdi-magnify"
                />
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.id="{ item }">{{ item.id | parcel }}</template>
          <template v-slot:item.fundoReserva="{ item }">{{
            item.fundoReserva | percent
          }}</template>
          <template v-slot:item.seguroVida="{ item }">{{
            item.seguroVida | percent
          }}</template>
          <template v-slot:item.taxaAdm="{ item }">{{
            item.taxaAdm | percent
          }}</template>

          <template v-slot:item.ativo="{ item }">
            <v-btn color="transparent" small fab depressed>
              <v-icon
                @click="updateAtivo(item)"
                :color="item.ativo ? 'green' : 'red'"
                >{{ item.ativo ? "mdi-check" : "mdi-close" }}</v-icon
              >
            </v-btn>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="transparent"
                  small
                  fab
                  v-on="on"
                  depressed
                  @click="$refs.dialogFormPrazo.show(true, item, consorcio)"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              Editar Prazos
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Prazo from "@/services/prazo";

export default {
  name: "DialogTablePrazos",

  components: {
    DialogFormPrazo: () => import("./DialogFormPrazo")
  },

  data() {
    return {
      headers: [
        { text: "Prazo", value: "id" },
        { text: "contemplacao", value: "contemplacao", align: "start" },
        { text: "fundoReserva", value: "fundoReserva", align: "start" },
        { text: "participantes", value: "participantes", align: "start" },
        { text: "seguroVida", value: "seguroVida", align: "start" },
        { text: "taxaAdm", value: "taxaAdm", align: "start" },
        { text: "vencimento", value: "vencimento", align: "start" },
        { text: "Ativo", value: "ativo", sortable: false },
        { text: "Ações", value: "acoes", sortable: false, align: "center" }
      ],
      data: [],
      search: "",
      dialog: {
        show: false,
        title: ""
      },
      servicePrazo: new Prazo(),
      consorcio: null
    };
  },

  methods: {
    async show(consorcio) {
      try {
        await this.getDataTable(consorcio);
        this.consorcio = consorcio;
        this.dialog.show = true;
        this.dialog.title = `Prazos do Consorcio ${consorcio.descricao}`;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getDataTable(consorcio) {
      try {
        const response = await this.servicePrazo.getByConsorcio(consorcio);
        this.data = response;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    updatePrazo(prazoUpdated) {
      const index = this.data.findIndex(prazo => prazo.id === prazoUpdated.id);
      this.data[index].contemplacao = prazoUpdated.contemplacao;
      this.data[index].fundoReserva = prazoUpdated.fundoReserva;
      this.data[index].participantes = prazoUpdated.participantes;
      this.data[index].seguroVida = prazoUpdated.seguroVida;
      this.data[index].taxaAdm = prazoUpdated.taxaAdm;
      this.data[index].vencimento = prazoUpdated.vencimento;
    },

    updateAtivo({ id, consorcioId, ...prazo }) {
      let estadoInicial = prazo.ativo;
      let texto = "";
      if (prazo.ativo) {
        texto = "Deseja Desativar Prazo?";
      } else {
        texto = "Deseja Ativar Prazo?";
      }
      this.$swal.confirm(texto).then(async () => {
        try {
          prazo.ativo = !prazo.ativo;
          await this.servicePrazo.updatePrazoConsorcio(
            this.consorcio,
            { ...prazo },
            id
          );
          this.getDataTable(this.consorcio);
          return Promise.resolve();
        } catch (error) {
          prazo.ativo = estadoInicial;
          await this.servicePrazo.updatePrazoConsorcio(
            this.consorcio,
            { ...prazo },
            id
          );
          this.$toast.error("Erro ao atualizar ativo");
          return Promise.reject(error);
        }
      });
    }
  }
};
</script>
